var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-not-found",attrs:{"id":"page-not-found"}},[_c('h2',{staticClass:"page-heading"},[_vm._v("404 Page Not Found")]),_c('p',{staticClass:"url"},[_vm._v(_vm._s(_vm.url))])])}
var staticRenderFns = []

export { render, staticRenderFns }